import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import "../Styles/AppBar.css";

function AppBar() {
  const [collapsed, setCollapsed] = useState(true); 
  const location = useLocation(); 
  const navigate = useNavigate();

  const handleChildSelect = (childKey) => {
    setCollapsed(true); 
  };

  
  const isActive = (path) => location.pathname === path;

  return (
    <Navbar
      expand="lg"
      className="bg-body-tertiary"
      fixed="top"
      onToggle={() => setCollapsed(!collapsed)}
      expanded={!collapsed}
      style={{ position: "sticky", top: 0, zIndex: 1000 }}
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand href="/home">
          <img
            src="logo.png"
            alt="Logo"
            style={{ height: "55px", width: "auto" }}
          />
        </Navbar.Brand>

        {/* Hamburger Icon */}
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{
            border: "none",
            backgroundColor: "transparent",
          }}
        >
     
          <span
            style={{
              backgroundColor: "#6a0dad", 
              display: "block",
              width: "25px",
              height: "3px",
              marginBottom: "5px",
              borderRadius: "2px",
            }}
          ></span>
        
          <span
            style={{
              backgroundColor: "#6a0dad", 
              display: "block",
              width: "25px",
              height: "3px",
              marginBottom: "5px",
              borderRadius: "2px",
            }}
          ></span>
         
          <span
            style={{
              backgroundColor: "#6a0dad",
              display: "block",
              width: "25px",
              height: "3px",
              borderRadius: "2px",
            }}
          ></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
          {/* Navigation */}
          <Nav
            className="mx-auto"
            style={{ fontSize: "18px", fontWeight: "600" }}
          >
            <Nav.Link
              href="/home"
              style={{
                color: isActive("/home") ? "#772c93" : "inherit",
                transition: "all 0.3s ease", 
              }}
              onClick={() => handleChildSelect("/home")}
              className="home-link-animation"
            >
              Home
            </Nav.Link>

            <Nav.Link
              href="/about"
              style={{ color: isActive("/about") ? "#772c93" : "inherit" }}
              onClick={() => handleChildSelect("/about")}
              className="home-link-animation"
            >
              About
            </Nav.Link>
            <Nav.Link
              href="/contact"
              style={{ color: isActive("/contact") ? "#772c93" : "inherit" }}
              onClick={() => handleChildSelect("/contact")}
              className="home-link-animation"
            >
              Contact Us
            </Nav.Link>
            <NavDropdown
              title={<span style={{ color: "#2a2829" }}>Services</span>}
              id="basic-nav-dropdown"
              className="home-link-animation"
            >
              {/* Development Dropdown */}
              <NavDropdown
                title="Development"
                id="development-dropdown"
                drop="end"
                style={{
                  color: isActive("/services/development")
                    ? "#772c93"
                    : "inherit",
                }}
              >
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/nodejs"
                  style={{ color: isActive("/nodejs") ? "#772c93" : "inherit" }}
                  onClick={() => handleChildSelect("/nodejs")}
                >
                  Node Js Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/reactjs"
                  style={{ color: isActive("reactjs") ? "#772c93" : "inherit" }}
                  onClick={() => handleChildSelect("/reactjs")}
                >
                  React Js Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/mobileapplication"
                  style={{
                    color: isActive("/mobileapplication")
                      ? "#772c93"
                      : "inherit",
                  }}
                  onClick={() => handleChildSelect("/mobileapplication")}
                >
                  Mobile App Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/webdevelopment"
                  style={{
                    color: isActive("/webdevelopment") ? "#772c93" : "inherit",
                  }}
                  onClick={() => handleChildSelect("/webdevelopment")}
                >
                  Web Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/ecommerce"
                  style={{
                    color: isActive("/ecommerce") ? "#772c93" : "inherit",
                  }}
                  onClick={() => handleChildSelect("/ecommerce")}
                >
                  ECommerce Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/java"
                  style={{ color: isActive("/java") ? "#772c93" : "inherit" }}
                  onClick={() => handleChildSelect("/java")}
                >
                  Java Development
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="development-dropdown"
                  href="/enterpriseappdevelopment"
                  style={{
                    color: isActive("/enterpriseappdevelopment")
                      ? "#772c93"
                      : "inherit",
                  }}
                  onClick={() => handleChildSelect("/enterpriseappdevelopment")}
                >
                  Enterprise App Development
                </NavDropdown.Item>
              </NavDropdown>

              {/* Consultation Dropdown */}
              <NavDropdown
                title="Consultation"
                id="consultation-dropdown"
                drop="end"
                style={{
                  color: isActive("/services/consultation")
                    ? "#772c93"
                    : "inherit",
                }}
              >
                <NavDropdown.Item
                  id="consultation-dropdown"
                  href="/alservices"
                  style={{
                    color: isActive("/alservices") ? "#772c93" : "inherit",
                  }}
                  onClick={() => handleChildSelect("/alservices")}
                >
                  AI / ML Services
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="consultation-dropdown"
                  href="/digitalmarketing"
                  style={{
                    color: isActive("/digitalmarketing")
                      ? "#772c93"
                      : "inherit",
                  }}
                  onClick={() => handleChildSelect("/digitalmarketing")}
                >
                  Digital Marketing
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="consultation-dropdown"
                  href="/itconsulting"
                  style={{
                    color: isActive("/itconsulting") ? "#772c93" : "inherit",
                  }}
                  onClick={() => handleChildSelect("/itconsulting")}
                >
                  IT Consulting
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="consultation-dropdown"
                  href="/cloudservicesmanagement"
                  style={{
                    color: isActive("/cloudservicesmanagement")
                      ? "#772c93"
                      : "inherit",
                  }}
                  onClick={() => handleChildSelect("/cloudservicesmanagement")}
                >
                  Cloud Service Management
                </NavDropdown.Item>
                <NavDropdown.Item
                  id="consultation-dropdown"
                  href="/solutionsdesign"
                  style={{
                    color: isActive("/solutionsdesign") ? "#772c93" : "inherit",
                  }}
                  onClick={() => handleChildSelect("/solutionsdesign")}
                >
                  Solutions Design
                </NavDropdown.Item>
              </NavDropdown>
            </NavDropdown>

            <Nav.Link
              href="/insights"
              style={{ color: isActive("/insights") ? "#772c93" : "inherit" }}
              onClick={() => handleChildSelect("/insights")}
              className="home-link-animation"
            >
              Insights
            </Nav.Link>
          </Nav>

          {/* Button */}
          <div className="d-flex justify-content-start justify-content-lg-end mt-3 mt-lg-0">
            <Button
              className="ms-lg-auto"
              style={{
                backgroundColor: "#772c93",
                color: "white",
                border: "none",
                padding: "8px 25px",
                borderRadius: "5px",
                fontSize: "18px",
                fontWeight: "600",
                transition: "all 0.3s ease-in-out",
              }}
              onClick={() => {
                handleChildSelect("/contact"); 
                navigate("/contact"); 
              }}              
            >
              Get in Touch
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppBar;
